var Top = /** @class */ (function () {
    function Top() {
        this.showTime = 1 * 1000; // ローディングを最低限見せたい秒数 * 1000 (ミリ秒)
        this.loadTime = new Date().getTime();
        this.init();
    }
    Top.prototype.init = function () { };
    Top.prototype.load = function () {
        var scope = this;
        var loadingTIme = new Date().getTime() - this.loadTime;
        var time = this.showTime - loadingTIme;
        if (time > 0) {
            setTimeout(function () {
                $('.loading').fadeOut(300);
                $('.loaded').fadeIn(500);
            }, time);
        }
        else {
            $('.loading').fadeOut(300);
            $('.loaded').fadeIn(500);
        }
        scope.setEvent();
        scope.showMain();
    };
    Top.prototype.showMain = function () {
        var scope = this;
        this.resetSlideShow();
        this.show();
        $('.mainvisual .nav_l a').on('click', function (event) {
            event.preventDefault();
            scope.resetSlideShow();
            scope.show_reverse();
        });
        $('.mainvisual .nav_r a').on('click', function (event) {
            event.preventDefault();
            scope.resetSlideShow();
            scope.show();
        });
    };
    ;
    Top.prototype.resetSlideShow = function () {
        var scope = this;
        if (this.intervalID) {
            clearInterval(this.intervalID);
        }
        this.intervalID = setInterval(function () {
            scope.show();
        }, 7000);
    };
    Top.prototype.show = function () {
        var len = $('.mainvisual ul li').length;
        var count = -1;
        var tgt = $('.mainvisual ul li');
        tgt.each(function (i, o) {
            if ($(o).hasClass('crnt') || $(o).hasClass('crnt_r')) {
                count = i;
            }
        });
        //var old = count;
        count = count + 1 >= len ? 0 : count + 1;
        tgt.removeClass('crnt crnt_r');
        //tgt.removeClass('crnt fadeout');
        /*if (old !== -1) {
            tgt.eq(old).addClass('fadeout');
        }*/
        tgt.eq(count).addClass('crnt');
    };
    Top.prototype.show_reverse = function () {
        var len = $('.mainvisual ul li').length;
        var count = -1;
        var tgt = $('.mainvisual ul li');
        tgt.each(function (i, o) {
            if ($(o).hasClass('crnt') || $(o).hasClass('crnt_r')) {
                count = i;
            }
        });
        //var old = count;
        count = count - 1 >= 0 ? count - 1 : len - 1;
        tgt.removeClass('crnt crnt_r');
        //tgt.removeClass('crnt fadeout');
        /*if (old !== -1) {
            tgt.eq(old).addClass('fadeout');
        }*/
        tgt.eq(count).addClass('crnt_r');
    };
    Top.prototype.setEvent = function () {
        var _this = this;
        // common
        $('#to_top_sp a, .to_top a').on('click', function (event) {
            $("html,body").animate({ scrollTop: '0px' }, 750, 'easeInOutExpo');
            event.preventDefault();
            return false;
        });
        // sp
        $('header .g_menu li a').on('click', function (event) {
            event.preventDefault();
            var links = $(event.currentTarget).attr('href');
            var pos = links === '#' ? 0 : $(links).offset().top;
            $("html,body").animate({ scrollTop: pos + 'px' }, 750, 'easeInOutExpo');
        });
        // PC
        $('header .hdr_menu li a').on('click', function (event) {
            event.preventDefault();
            var links = $(event.currentTarget).attr('href');
            var pos = $(links).offset().top;
            $("html,body").animate({ scrollTop: pos + 'px' }, 750, 'easeInOutExpo');
        });
        $('header .btn_menu').on('click', function (event) {
            event.preventDefault();
            $('header .g_menu').stop(true, false).slideToggle();
            $('header .sns_menu').stop(true, false).delay(250).slideToggle();
        });
        $('header .g_menu a').on('click', function (event) {
            event.preventDefault();
            //
            //
            $('header .g_menu').stop(true, false).slideUp();
            $('header .sns_menu').stop(true, false).delay(250).slideUp();
        });
        $('.soy_items .btn_left a').on('click', function (event) {
            event.preventDefault();
            //
            var tgt = $('.soy_items ul.items li');
            var len = tgt.length;
            var cnt = 0;
            tgt.each(function (i, item) {
                if ($(item).hasClass('active_l') || $(item).hasClass('active_r')) {
                    cnt = i;
                }
            });
            var old = cnt;
            cnt = cnt - 1 >= 0 ? cnt - 1 : len - 1;
            tgt.removeClass('active_l active_r deactive_l deactive_r');
            tgt.eq(cnt).addClass('active_l');
            tgt.eq(old).addClass('deactive_l');
        });
        $('.soy_items .btn_right a').on('click', function (event) {
            event.preventDefault();
            //
            var tgt = $('.soy_items ul.items li');
            var len = tgt.length;
            var cnt = 0;
            tgt.each(function (i, item) {
                if ($(item).hasClass('active_r') || $(item).hasClass('active_l')) {
                    cnt = i;
                }
            });
            var old = cnt;
            cnt = cnt + 1 >= len ? 0 : cnt + 1;
            tgt.removeClass('active_l active_r deactive_l deactive_r');
            tgt.eq(cnt).addClass('active_r');
            tgt.eq(old).addClass('deactive_r');
        });
        $('.chia_list .nav li.left a').on('click', function (event) {
            event.preventDefault();
            //
            var tgt = $('.chia_list .product_list ul li');
            var len = tgt.length;
            var cnt = 0;
            tgt.each(function (i, item) {
                if ($(item).hasClass('active_l') || $(item).hasClass('active_r')) {
                    cnt = i;
                }
            });
            var old = cnt;
            cnt = cnt - 1 >= 0 ? cnt - 1 : len - 1;
            tgt.removeClass('active_l active_r deactive_l deactive_r');
            tgt.eq(cnt).addClass('active_l');
            tgt.eq(old).addClass('deactive_l');
        });
        $('.chia_list .nav li.right a').on('click', function (event) {
            event.preventDefault();
            //
            var tgt = $('.chia_list .product_list ul li');
            var len = tgt.length;
            var cnt = 0;
            tgt.each(function (i, item) {
                if ($(item).hasClass('active_r') || $(item).hasClass('active_l')) {
                    cnt = i;
                }
            });
            var old = cnt;
            cnt = cnt + 1 >= len ? 0 : cnt + 1;
            tgt.removeClass('active_l active_r deactive_l deactive_r');
            tgt.eq(cnt).addClass('active_r');
            tgt.eq(old).addClass('deactive_r');
        });
        //PC
        $('.chia_items .btn_left a').on('click', function (event) {
            event.preventDefault();
            //
            var tgt = $('.chia_items ul li');
            var len = tgt.length;
            var cnt = 0;
            tgt.each(function (i, item) {
                if ($(item).hasClass('active_l') || $(item).hasClass('active_r')) {
                    cnt = i;
                }
            });
            var old = cnt;
            cnt = cnt - 1 >= 0 ? cnt - 1 : len - 1;
            tgt.removeClass('active_l active_r deactive_l deactive_r');
            tgt.eq(cnt).addClass('active_l');
            tgt.eq(old).addClass('deactive_l');
        });
        $('.chia_items .btn_right a').on('click', function (event) {
            event.preventDefault();
            //
            var tgt = $('.chia_items ul li');
            var len = tgt.length;
            var cnt = 0;
            tgt.each(function (i, item) {
                if ($(item).hasClass('active_r') || $(item).hasClass('active_l')) {
                    cnt = i;
                }
            });
            var old = cnt;
            cnt = cnt + 1 >= len ? 0 : cnt + 1;
            tgt.removeClass('active_l active_r deactive_l deactive_r');
            tgt.eq(cnt).addClass('active_r');
            tgt.eq(old).addClass('deactive_r');
        });
        this.scroll(null);
        $(window).on('scroll', function (e) { _this.scroll(e); });
        $(window).on('resize', function (e) { _this.resize(e); });
    };
    Top.prototype.resize = function (e) {
        var wid = $(window).innerWidth();
        var hig = $(window).innerHeight();
    };
    Top.prototype.scroll = function (e) {
        this.resize(null);
        var scTop = $(window).scrollTop();
        var winH = $(window).innerHeight();
        var per = 0.95;
        var tgt = $('.scrl, .scrl2');
        tgt.each(function (i, o) {
            if ($(o).offset().top < scTop + (winH * per) && !$(o).hasClass('show')) {
                $(o).addClass('show');
            }
        });
        if (scTop < 100 && !$('.to_top').hasClass('hide')) {
            $('.to_top').addClass('hide');
        }
        if (scTop > 100 && $('.to_top').hasClass('hide')) {
            $('.to_top').removeClass('hide');
        }
    };
    return Top;
}());
export { Top };
(function () {
    var _top;
    document.addEventListener("DOMContentLoaded", function (event) {
        _top = new Top();
    });
    window.onload = function () {
        _top.load();
    };
})();
